/* eslint-disable no-unused-vars */
import { createStore } from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import engine from './modules/engine';
import scene from './modules/scene';
import ui from './modules/ui';
import engineObj from './modules/engineObj';

import config from '../config';
import asfaVariables from '../config/asfaVariables.json';

const totals = asfaVariables.totals;
const pension = asfaVariables.pension;
const categories = asfaVariables.categories;

config.headlineFigures = {
  single: {
    minimum: pension.pensionSingle * 26,
    moderate: totals.modestSingleYearTotal,
    comfortable: totals.comfortableSingleYearTotal,
  },

  cohabiting: {
    minimum: pension.pensionCouple * 52,
    moderate: totals.modestCoupleYearTotal,
    comfortable: totals.comfortableCoupleYearTotal,
  }
};

const keys = [ 'house', 'communications', 'transport', 'personal', 'eatout', 'holiday', 'food', 'leisure', 'health' ];

const single = Object.fromEntries(keys.map(k => [k, {
  A: categories[k].pension.single,
  B: categories[k].modest.single,
  C: categories[k].comfortable.single
}]));

const cohabiting = Object.fromEntries(keys.map(k => [k, {
  A: categories[k].pension.couple,
  B: categories[k].modest.couple,
  C: categories[k].comfortable.couple
}]));

config.targetIncomes = { single, cohabiting };

export default createStore({
  // namespaced: true,
  modules: {
    engine,
    scene,
    ui,
    engineObj
  },
  state: {
    config,
    debugMode: false,
    appVersion: process.env.APP_VERSION || '0',
  },
  getters: {
    getField,
    isDevelopment: state => process.env.NODE_ENV === "development",
    // TODO: relies on 'single' key at the moment as we only have one set of copy at the moment. If this changes in future add cohabiting copy in client config and make this getter rely on the cohabiting key instead of 'single'
    getQuestionAnswerData: state => key => state.config.questionAnswerData.single[key],
    debugMode: state => {
      return state.debugMode;
    },
    appVersion: state => {
      return state.appVersion;
    },
  },
  mutations: {
    updateField,
  },
});
